import TokenCalculator from "@/components/dashboard/TokenCalculator";
import { useQuery } from "@apollo/client/react";
import { GET_CREDITS, GET_SUBSCRIPTION_PLAN } from "@/graphql/queries";
import { ApiErrorScreen, useHasCriticalError } from "@/components/ApiErrorScreen";

type SubscriptionPlan = 'PERSONAL' | 'PRO' | 'STUDIO' | 'ENTERPRISE';
const VALID_PLANS: SubscriptionPlan[] = ['PERSONAL', 'PRO', 'STUDIO', 'ENTERPRISE'];

const Calculator = () => {
  // Fetch actual credits data
  const { data: creditsData, loading: creditsLoading, error: creditsError } = useQuery<{ credits?: { balance?: number } | null }>(GET_CREDITS, { errorPolicy: 'all' });
  const { data: subscriptionData, loading: subscriptionLoading, error: subscriptionError } = useQuery<{ subscription?: { plan?: string } | null }>(GET_SUBSCRIPTION_PLAN, { errorPolicy: 'all' });

  // Check for critical errors
  const queryErrors = [creditsError, subscriptionError];
  const hasCriticalErrors = useHasCriticalError(queryErrors);

  const credits = creditsData?.credits?.balance || 0;
  const rawPlan = subscriptionData?.subscription?.plan;
  const currentPlan: SubscriptionPlan = VALID_PLANS.includes(rawPlan as SubscriptionPlan) ? rawPlan as SubscriptionPlan : "PERSONAL";

  // Show blocking error screen when critical APIs fail
  if (hasCriticalErrors) {
    return (
      <ApiErrorScreen 
        errors={queryErrors}
        context="Dashboard - Calculator"
      />
    );
  }

  return (
    <div className="container mx-auto px-6 py-8 max-w-7xl">
      <div className="space-y-6">
        <div>
          <h1 className="text-4xl font-bold bg-gradient-hero bg-clip-text text-transparent">
            Flow Credits Calculator
          </h1>
        </div>

        {creditsLoading || subscriptionLoading ? (
          <div className="text-center text-muted-foreground py-8">
            Loading credits...
          </div>
        ) : (
          <TokenCalculator availableCredits={credits} currentPlan={currentPlan} />
        )}
      </div>
    </div>
  );
};

export default Calculator;
